import { useEffect } from 'react'
import { Config } from '@chegg-wt/core/config'

export function useSetVersion() {
  useEffect(() => {
    window.whoAmI = () => Config.ucfVer
  }, [])
}
